import { Action, createAction, handleActions } from "redux-actions";
import { GetSiniestrosResponse, SiniestroResponse } from "~api/types";
import {
  Dispatch,
  FechaFiltro,
  FiltroValue,
  GetState,
  ServicesListadoSiniestros,
  aFechaRequest,
} from "../../types";

export interface ListadoSiniestrosState {
  siniestros: SiniestroResponse[] | null;
  isLoading: boolean;
  failed: boolean;
  totalRegistros: number;
  siniestroModificado: boolean;
}

/** Los filtros con los que se pide el listado, tal como los tiene la pantalla. */
export interface GetSiniestrosParams {
  skip: number;
  take: number;
  searchCriteria: string;
  estado: FiltroValue;
  tipo: FiltroValue | null;
  fechaDesde: FechaFiltro;
  fechaHasta: FechaFiltro;
}

const setInitialState = createAction("SET_INITIAL_STATE_SINIESTROS");

const getSiniestrosInited = createAction("OBTENER_SINIESTROS_INITED");

const getSiniestrosCompleted = createAction(
  "OBTENER_SINIESTROS_COMPLETED",
  (response: GetSiniestrosResponse | null | undefined) => {
    let siniestros: SiniestroResponse[] = [];
    let totalRegistros = 0;

    if (typeof response !== "undefined" && response !== null) {
      siniestros = response.siniestros;
      totalRegistros = response.totalRegistros;
    }

    return { siniestros, totalRegistros };
  }
);

const getSiniestrosFailed = createAction(
  "OBTENER_SINIESTROS_FAILED",
  (error: unknown) => ({
    error,
  })
);

const closeSuccessEstadoPopUp = createAction("CLOSE_SUCCESS_ESTADO_POPUP");

const patchSiniestroTipoInited = createAction("PATCH_TIPO_SINIESTRO_INITED");

const patchSiniestroTipoCompleted = createAction(
  "PATCH_TIPO_SINIESTRO_COMPLETED"
);

const patchSiniestroTipoFailed = createAction(
  "TIPO_SINIESTRO_FAILED",
  (error: unknown) => ({
    error,
  })
);

const patchSiniestroEstadoInited = createAction(
  "PATCH_ESTADO_SINIESTRO_INITED"
);

const patchSiniestroEstadoCompleted = createAction(
  "PATCH_ESTADO_SINIESTRO_COMPLETED"
);

const patchSiniestroEstadoFailed = createAction(
  "PATCH_ESTADO_SINIESTRO_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getSiniestros = ({
  skip,
  take,
  searchCriteria,
  estado,
  tipo,
  fechaDesde,
  fechaHasta,
}: GetSiniestrosParams) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesListadoSiniestros
  ) => {
    try {
      dispatch(getSiniestrosInited());

      const data = {
        skip,
        take,
        searchCriteria,
        estado: String(estado),
        tipo: tipo ? String(tipo) : undefined,
        fechaDesde: aFechaRequest(fechaDesde),
        fechaHasta: aFechaRequest(fechaHasta),
      };

      const response = await services.api.siniestros().getSiniestros(data);

      dispatch(getSiniestrosCompleted(response));
    } catch (error) {
      console.log(error);
      dispatch(getSiniestrosFailed(error));
    }
  };
};

const patchSiniestroEstado = (
  siniestroId: string,
  estado: string,
  motivo: string | null,
  comentarioRechazo: string,
  numeroSiniestroCompania: string
) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesListadoSiniestros
  ) => {
    try {
      dispatch(patchSiniestroEstadoInited());

      const data = {
        estado,
        motivo,
        comentarioRechazo,
        numeroSiniestroCompania,
      };

      await services.api.siniestros().patchSiniestroEstado(siniestroId, data);

      dispatch(patchSiniestroEstadoCompleted());
    } catch (error) {
      console.log(error);
      dispatch(patchSiniestroEstadoFailed(error));
    }
  };
};

const patchSiniestroTipo = (siniestroId: string, tipo: string) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesListadoSiniestros
  ) => {
    try {
      dispatch(patchSiniestroTipoInited());

      const data = {
        tipo,
      };

      console.log(data);

      await services.api.siniestros().patchSiniestroTipo(siniestroId, data);

      dispatch(patchSiniestroTipoCompleted());
    } catch (error) {
      console.log(error);
      dispatch(patchSiniestroTipoFailed(error));
    }
  };
};

const listadoSiniestrosInitialState: ListadoSiniestrosState = {
  siniestros: null,
  isLoading: false,
  failed: false,
  totalRegistros: 0,
  siniestroModificado: false,
};

const listadoSiniestrosReducer = handleActions<ListadoSiniestrosState, any>(
  {
    [setInitialState.toString()]: (): ListadoSiniestrosState => {
      return {
        ...listadoSiniestrosInitialState,
      };
    },
    [getSiniestrosInited.toString()]: (
      state: ListadoSiniestrosState
    ): ListadoSiniestrosState => {
      return {
        ...state,
        totalRegistros: 0,
        isLoading: true,
      };
    },
    [getSiniestrosCompleted.toString()]: (
      state: ListadoSiniestrosState,
      action: Action<{
        siniestros: SiniestroResponse[];
        totalRegistros: number;
      }>
    ): ListadoSiniestrosState => {
      return {
        ...state,
        totalRegistros: action.payload.totalRegistros,
        siniestros: action.payload.siniestros,
        isLoading: false,
        failed: false,
      };
    },
    [getSiniestrosFailed.toString()]: (
      state: ListadoSiniestrosState
    ): ListadoSiniestrosState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
      };
    },
    [patchSiniestroEstadoInited.toString()]: (
      state: ListadoSiniestrosState
    ): ListadoSiniestrosState => {
      return {
        ...state,
        isLoading: true,
        siniestroModificado: false,
      };
    },
    [patchSiniestroEstadoCompleted.toString()]: (
      state: ListadoSiniestrosState
    ): ListadoSiniestrosState => {
      return {
        ...state,
        isLoading: false,
        siniestroModificado: true,
      };
    },
    [patchSiniestroEstadoFailed.toString()]: (
      state: ListadoSiniestrosState
    ): ListadoSiniestrosState => {
      return {
        ...state,
        isLoading: false,
        siniestroModificado: false,
      };
    },
    [patchSiniestroTipoInited.toString()]: (
      state: ListadoSiniestrosState
    ): ListadoSiniestrosState => {
      return {
        ...state,
        isLoading: true,
        siniestroModificado: false,
      };
    },
    [patchSiniestroTipoCompleted.toString()]: (
      state: ListadoSiniestrosState
    ): ListadoSiniestrosState => {
      return {
        ...state,
        isLoading: false,
        siniestroModificado: true,
      };
    },
    [patchSiniestroTipoFailed.toString()]: (
      state: ListadoSiniestrosState
    ): ListadoSiniestrosState => {
      return {
        ...state,
        isLoading: false,
        siniestroModificado: false,
      };
    },
    [closeSuccessEstadoPopUp.toString()]: (
      state: ListadoSiniestrosState
    ): ListadoSiniestrosState => {
      return {
        ...state,
        siniestroModificado: false,
      };
    },
  },
  listadoSiniestrosInitialState
);

export { listadoSiniestrosReducer };

export {
  getSiniestros,
  closeSuccessEstadoPopUp,
  patchSiniestroEstado,
  patchSiniestroTipo,
};
